module.exports = __webpack_public_path__ + "img/revi-logo.df62383f.png";